// extracted by mini-css-extract-plugin
export default {"root":"styles_root__IXYLl","text":"styles_text__cAlv1"};